module.exports = __webpack_public_path__ + "img/havefun_title_tc.77417a06.jpg";